export var isToday = function isToday(date) {
  return new Date().toDateString() === date.toDateString();
};